var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-wrapper"},[_c('Headertwo'),_c('div',{staticClass:"main-content"},[_vm._t("default")],2),(_vm.footerStyle === 1)?_c('Footer'):_vm._e(),(_vm.footerStyle === 2)?_c('Footertwo'):_vm._e(),(_vm.footerStyle === 3)?_c('Footerthree'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }